import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';

import MiniGame from '../pages/MiniGame';



function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/rymversus" element={<MiniGame />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;